module.exports = __webpack_public_path__ + "img/access.9f2693f8.png";